import React from "react"
import { useState } from "react";
import AlertBox from "../../shared/AlertBox";
import { Breadcrumb } from "antd";
import NettingCustomerSearch from "./NettingCustomerSearch";
import NettingInformationScreen from "./NettingInfomationScreen";
import { getCurrenciesByCustomer } from "../../../networking/NetworkingCurrencies";
import NettingListScreen from "./NettingListScreen";
import NettingSummaryScreen from "./NettingSummaryScreen";

const  NettingScreen = () => {
    const [step, setStep] = useState(1);
    const [alertTitle, setAlertTitle] = useState('');
    const [alertMessage, setAlertMessage] = useState('');
    const [showAlert, setShowAlert] = useState(false);
    const [objCustomer, setObjCustomer] = useState({});
    const [settlementCurrencies, setSettlementCurrencies] = useState([]);
    const [buyCurrency, setBuyCurrency] = useState('');
    const [selectedBuyCcy, setSelectedBuyCcy] = useState('');
    const [orderBuySelections, setOrderBuySelections] = useState({});
    const [orderSellSelections, setOrderSellSelections] = useState({});
    const [balanceBuy, setBalanceBuy] = useState(0);
    const [balanceSell, setBalanceSell] = useState(0);
    const [isView, setIsView] = useState(false);

    const [objNetting, setObjNetting] = useState({
            NettingNo:0,
             CustomerID: -1
        });

    const loadCurrencies = async (customerID) => {
            const currenciesResponse = await getCurrenciesByCustomer(customerID)
                    
            if(currenciesResponse && currenciesResponse.currencies)
            {
                const formattedCurrencies = currenciesResponse.currencies.map(c => ({ ...c, name: c.CurrencyIDName, value: c.CurrencyID }));
                const finalSettelementCurrencies = [];
                formattedCurrencies.forEach(element => {
                switch (element.Type) {
                    case 'Settlement':
                    finalSettelementCurrencies.push(element);
                    break;
                    default:
                    break;
                }
                });
                setSettlementCurrencies(finalSettelementCurrencies);
            }              
        }
    
    const handleCustomerSelection = async(obj, nextStep) => {

            //Show status warning
            if (obj.Status !== 'Regular' && obj.Status !== 'Monitored') {//(obj.Status !== 'Authorized to deal') {
                nextStep = 1;
                setAlertMessage('Customer is in ' + obj.Status + ' status. Orders cannot be created or edited under this customer.');
                setAlertTitle('Warning');
                setShowAlert(true);
            }
            else
            {
                setObjCustomer(obj);
                loadCurrencies(obj['Customer ID']);
                
                if (nextStep === 2) {                
                    setStep(nextStep);
                    setObjNetting({});
                }
        }
    }

    const onChangeBuyCurrency = (buyCcy, labelCcy) => {
        setObjNetting({...objNetting, BuyCurrency: buyCcy});
        setBuyCurrency(buyCcy);
        setSelectedBuyCcy(labelCcy);
    }

    const onNew = () => {
        setIsView(false);
        setStep(3);        
    }

    const onBackCurrency = () => {
        setStep(2);
    }

    const onNext = (orderBuySelections, orderSellSelections, buyBalance, sellBalance) => {
        setOrderBuySelections(orderBuySelections);
        setOrderSellSelections(orderSellSelections);
        setBalanceBuy(buyBalance);
        setBalanceSell(sellBalance);
        setStep(4);
    }

    const onBackNettingInfo = () => {
        setStep(3);
    }

    const ViewNettingDetails = (orderBuySelections, orderSellSelections, buyBalance, sellBalance) => {
        setOrderBuySelections(orderBuySelections);
        setOrderSellSelections(orderSellSelections);
        setBalanceBuy(buyBalance);
        setBalanceSell(sellBalance);
        setStep(4);
        setIsView(true);
    }

  const getTab = () =>{
        if (step === 1 || step === 5) {
            //if(validEoD)
            //{
                return (
                    <ul className="uk-tab">
                        <li key="step-1" className={step !== 5? 'uk-active':''}><a onClick={() => setStep(1)}>Search Customer</a></li>
                    </ul>
                );
            /*}
            else
            {
                return (
                    <ul className="uk-tab">
                        <li key="step-5" className={step === 5? 'uk-active':''}><a onClick={() => setStep(5)}>Order Search</a></li>
                    </ul>
                );
            }*/
        }
        else
            return <></>
    }

    const getBreadcrumb = () =>{
        let breadcrumb = [];
        const nettingNo = (objNetting && objNetting.NettingNo > 0)? `: ${objNetting.NettingNo}`:'';
         switch (step) {
                    case 1:
                    default:
                        breadcrumb.push(<Breadcrumb.Item key="bd-order" className="breadcrumb-item-bold" onClick={() =>  setStep(1)}>{`Netting ${nettingNo}`}</Breadcrumb.Item>)   
                        break;
                    case 2:
                        breadcrumb.push(
                                        <Breadcrumb.Item key="bd-order" className="breadcrumb-item" onClick={() => setStep(1)}>{`Netting Information`}</Breadcrumb.Item>
                                    );
                        break;
                    }
        return breadcrumb;
    }

    const getStepScreen = () =>{
        let screen = <></>;
         switch (step) {
                    case 1:
                    default:
                        screen = (<NettingCustomerSearch id="comp_customer_form"
                            onCustomerSelected={handleCustomerSelection} />);         
                        break;
                    case 2:
                        screen = (<NettingListScreen id="comp_nettinglist_form" customerID={objCustomer['Customer ID']} customerName={objCustomer['Customer Name']} settlementCurrenciesList={settlementCurrencies}
                            onChangeBuyCurrency={onChangeBuyCurrency} onNewNetting={onNew} ViewNettingDetails={ViewNettingDetails} />);
                        break;                    
                    case 3:
                        screen = (<NettingInformationScreen id="comp_netting_form" customerID={objCustomer['Customer ID']} customerName={objCustomer['Customer Name']} buyCurrency={buyCurrency} selectedBuyCcy={selectedBuyCcy}
                            onBackCurrency={onBackCurrency} onNextSummary={onNext} />);
                        break;
                    case 4:
                        screen = (<NettingSummaryScreen id="comp_netting_form" customerID={objCustomer['Customer ID']} customerName={objCustomer['Customer Name']} buyCurrency={buyCurrency} selectedBuyCcy={selectedBuyCcy}
                            onBackNettingInfo={onBackNettingInfo} onCancelSummary={onBackCurrency} ordersBuy={orderBuySelections} ordersSell={orderSellSelections} balanceBuy={balanceBuy} balanceSell={balanceSell}
                            isView={isView} />);
                        break;
                    }
        return screen;
    }

    return (
        <>
        <div className="breadcrumb-div">
            <Breadcrumb separator=">">
                {getBreadcrumb()}
            </Breadcrumb>
        </div>
            {getTab()}
            {getStepScreen()}
        <AlertBox id="warning-alert"
                open={showAlert}
                title={alertTitle}
                message={alertMessage}
                type="Ok"
                okClick={() => setShowAlert(false)}
        />
        </>
    );
}

export default NettingScreen;